import { render, staticRenderFns } from "./AlertReport.vue?vue&type=template&id=1224b3ca&scoped=true&"
import script from "./AlertReport.vue?vue&type=script&lang=js&"
export * from "./AlertReport.vue?vue&type=script&lang=js&"
import style0 from "./AlertReport.vue?vue&type=style&index=0&id=1224b3ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224b3ca",
  null
  
)

export default component.exports